<template>
    <div class="div_margin" style="background-color: #fff; margin: 20px;">
        <div class="flex_box">
            <div class="flex_box_left">
                <div class="flex_box_left_center">
                    <el-tabs v-model="tabSelected" :tab-position="tabPosition" @tab-click="changeRole">
                        <el-tab-pane v-for="(item, index) in roleDataArray" :key="index" :label="item.name" />
                    </el-tabs>
                </div>
            </div>

            <div class="flex_box_right">
                <div class="flex_box_right">
                    <pageIndex1 v-if="tabSelectIndex == 0"></pageIndex1>
                    <pageIndex2 v-if="tabSelectIndex == 1" ref="add"></pageIndex2>
                    <pageIndex3 v-if="tabSelectIndex == 2" ref="add1"></pageIndex3>
                </div>
            </div>
        </div>
        <Add :title="title" :show="showForm" :edit-info="editInfo" :add-show-index="addShowIndex"
            @close="showForm = false; editInfo = null;"  @finish="init" />
        <Add1 :title="title" :show="showForm1" :edit-info="editInfo1" :add-show-index="addShowIndex1"
            @close="showForm1 = false; editInfo1 = null;" @finish="init1"   />
        <!-- @finish="init" -->

        <!-- <div style="text-align: center;">
            <el-button type="primary" style="bottom: 20px;position:fixed;" @click="saveClick()">保存</el-button>
        </div> -->
    </div>
</template>
  
<script>
import pageIndex1 from "./comp2/index1";
import pageIndex2 from "./comp2/index2";
import pageIndex3 from "./comp2/index3";
import Add from '../components/comp2/comIndex2/add'
import Add1 from '../components/comp2/comIndex3/add'
export default {
    components: {
        pageIndex1,
        pageIndex2,
        pageIndex3,
        Add,
        Add1,
    },
    data () {
        return {
            tabPosition: 'left',
            tabSelected: '',
            tabSelectIndex: 0,
            roleDataArray: [
                { name: "基本设置" },
                { name: "参展展品和服务" },
                { name: "应用领域" },
            ],
            menuArray: [],
            checked: [],
            rolesIdsDataArray: [],
            defaultChecked: [],

            // Add参数
            showForm: false,
            editInfo: null,
            addShowIndex: 0,
            title: '',
            showForm1: false,
            editInfo1: null,
            addShowIndex1: 0,
        }
    },
    mounted () {
        // this.getRoleData()
        // this.getMenuItem()
    },
    methods: {
        changeRole (tab, event) {
            this.tabSelectIndex = tab.index
            if (this.tabSelectIndex == 1) {
                this.$emit('fatherMethod2', true,false)
            } else if(this.tabSelectIndex == 2){
                this.$emit('fatherMethod2', false,true)
            }else{
                this.$emit('fatherMethod2', false,false)
            }
            console.log(tab.index)
            // this.$refs.tree.setCheckedKeys([])
            // if (JSON.parse(this.roleDataArray[this.tabSelectIndex].permissions.length > 0)) {
            //     this.defaultChecked = JSON.parse(this.roleDataArray[this.tabSelectIndex].permissions[0].codeId)
            // } else {
            //     this.defaultChecked = []
            // }
        },
        addClick () {
            this.showForm = true
            this.title = '新增参展展品和服务'
            this.addShowIndex = 1
        },
        addClick2 () {
            this.showForm1 = true
            this.title = '新增应用领域'
            this.addShowIndex1 = 1
        },
        init(){
            this.$refs.add.init()
        },
        init1(){
            this.$refs.add1.init()
        },

        



    }
}
</script>
  
<style lang="scss" scoped>
.flex_box_right {
    overflow: auto;
    height: 100%;
    margin-bottom: 30px;
}

.flex_box {
    display: flex;
    margin-top: 20px;

    &_left {
        width: 220px;
        display: flex;
        justify-content: end;

        &_center {
            display: flex;
        }
    }

    &_right {
        width: 100%;
    }
}

.saveClass {
    text-align: center;
}

.div_margin {
    min-height: 890px;
}
</style>
  